





































import {Vue, Component, Prop} from 'vue-property-decorator';
import {Getter, Mutation} from 'vuex-class';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import {DataSetMetadata, ExplorerConfiguration, ExplorerView, IDataTableHeader} from '@/types';
import FieldSelectionCard from '@/components/dataexplorer/FieldSelectionCard.vue';
import ShareViewCard from '@/components/dataexplorer/ShareViewCard.vue';
import ExplorerService from '@/services/explorer.service';

@Component({
  components: {ShareViewCard, FieldSelectionCard, GenericButton, ConfirmButton, CancelButton, Dialog},
})
export default class EditViewConfigurationDialog extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeOrganisation: any;
  @Getter private login: any;
  @Mutation private setView!: any;
  @Prop({default: null}) private view!: ExplorerView | null;
  @Prop({default: null}) private metadata!: DataSetMetadata | null;

  private fields: Record<string, any> = {};

  public get metadataPromise() {
    return Promise.resolve(this.metadata);
  }

  private get preSelectedFields(): Array<{[key: string]: boolean | string | number | undefined}> | undefined {
    if (this.view && this.view.configuration && Array.isArray(this.view.configuration.layout.headers)) {
      const allHeaders = this.view.configuration.layout.removedHeaders ? this.view.configuration.layout.headers.concat(this.view.configuration.layout.removedHeaders) : this.view.configuration.layout.headers;
      return allHeaders.map((h) => {
        if (h.isCustomField) {
          return { checked: true, text: h.text, value: h.value, id: h.id };
        } else {
          return { checked: false, text: h.text, value: h.value, id: h.id };
        }
      });
    }
  }

  private async editView() {
    if (this.view) {
      const layout = this.view.configuration.layout;

      if (this.fields.removedFields) {
        for (const field of this.fields.removedFields) {
          layout.headers = layout.headers.filter((h) => h.value !== field.value);
          layout.removedHeaders = layout.removedHeaders.filter((h) => h.value !== field.value);
        }
      }
      for (const field in this.fields.displayFields) {
        if (this.fields.displayFields.hasOwnProperty(field)) {
          const newHeader = {
              text: this.fields.displayFields[field].text,
              id: this.fields.displayFields[field].id,
              value: this.fields.displayFields[field].value,
              isCustomField: true,
          };

          if (layout.headers.map((h) => h.value).includes(field)) { // Update a present column
            const index = layout.headers.findIndex((h) => h.value === field);
            layout.headers.splice(index, 1, newHeader);
          } else if (layout.removedHeaders.map((h) => h.value).includes(field)) { // Update a present column
            const index = layout.removedHeaders.findIndex((h) => h.value === field);
            layout.removedHeaders.splice(index, 1, newHeader);
          } else {
            layout.headers.push(newHeader);
          }
        }
      }

      await ExplorerService.updateExplorerViewConfiguration(this.view);
      this.$emit('update:viewEdited', this.view);
      this.closeDialog();
    }
  }

  private updateFields(fields: any) {
    this.fields = fields;
  }

  private closeDialog() {
    this.$emit('close:dialog', {loading: false, open: false});
  }
}
